import axios from 'axios';
import { CATEGORIES_RECV_DATA, CATEGORIES_RECV_ERROR } from '../constants/actions';

import baseUrl from '../utils/baseUrl';

function g() {
	return { type: actionTypes.JOBS_REQ_DATA };
};

function receiveData(json) {
	return {
		type: CATEGORIES_RECV_DATA,
		payload: json,
	};
};

function receiveError(json) {
	return {
		type: CATEGORIES_RECV_ERROR,
		payload: json,
	};
};

export function fetchCategories() {
	return function(dispatch) {
		return axios.post(baseUrl + '/api/categories')
		.then(function(response) {
			dispatch(receiveData(response.data));
		})
		.catch(function(response) {
			dispatch(receiveError(response.data));
			//dispatch(pushState(null, '/error'));
		});
	};
};



/** WEBPACK FOOTER **
 ** ./frontend/actions/categories.js
 **/